module.exports = __webpack_public_path__ + "static/media/BNHA BG.5a871bb1.png";